<template>
<div>
    <div class="text-content-section">
      <h2 class="card-title">Reset Your Password</h2>
      <div v-if="serverErrors.length > 0" class="alert alert-danger" role="alert">
          <ul>
              <li v-for="(item, index) in serverErrors" :key="index">{{item}}</li>
          </ul>
      </div>
      <div class="form-group col-lg-4">
          <input v-model="password" v-validate="'required|min:8|verify_password'" :class="{'has-error': errors.has('password')}" name="password" type="password" class="form-control" placeholder="Password" ref="password">
          <div v-if="errors.has('password')" class="alert alert-danger mt-1">
              {{ errors.first('password') }}
          </div>
      </div>
      <div class="form-group col-lg-4">
          <input v-model="confirmPassword" v-validate="'required|confirmed:password'" :class="{'has-error': errors.has('password_confirmation')}" name="password_confirmation" type="password" class="form-control" placeholder="Confirm Password" data-vv-as="password">
          <div v-if="errors.has('password_confirmation')" class="alert alert-danger mt-1">
              {{ errors.first('password_confirmation') }}
          </div>
      </div>
      <button v-on:click="resetPassword" type="submit" class="btn vesta-gray-btn col-lg-4 col-sm-12">Reset Password</button>
    </div>
</div>
</template>

<style>

.has-error {
    border-color: red;
}
</style>

<script>
/* eslint-disable */
import axios from 'axios'
import Router from 'vue-router'
export default {
    data() {
        return {
            serverErrors: [],
            //email: '',
            password: '',
            confirmPassword: ''
        }
    },
    methods: {
        resetPassword: function (e) {
          const vm = this;
          this.$validator
            .validateAll()
            .then(function (passValidation) {
              if (passValidation) {
                axios.post('/api/Account/ResetPasswordLoggedIn', {
                  Password: vm.password,
                  ConfirmPassword: vm.confirmPassword
                }).then(function (response) {
                  vm.$router.push({name: 'ResetPasswordSuccessLoggedIn' });
                });
              } else {
                e.preventDefault();
              }
          })
          .catch(function () {
            e.preventDefault();
          });
        }
    }
}
</script>
